<template>
  <el-select :value="value"
             class="nav-item select-default"
             v-bind="$attrs"
             v-on="$listeners">
    <el-option v-for="lang in languages"
               class="select-default"
               :value="lang.locale"
               :label="lang.name"
               :key="lang.id">
    </el-option>
  </el-select>
</template>

<script>
  import uniqBy from 'lodash/uniqBy'
  import { Select, Option } from 'element-ui';
  import { mapState } from 'vuex';

  export default {
    name: 'language-select',
    inheritAttrs: false,
    props: {
      value: [String, Number]
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    computed: {
      ...mapState('language', {
        languages: state => {
          const languages = state.languages.filter(l => l.active)
          return uniqBy(languages, 'locale')
        }
      })
    }
  }
</script>

<style scoped>

</style>
